export default __webpack_public_path__ + "static/media/twittericon.dccd93ea.svg";